import { TableCell, TableHead, TableRow } from "@mui/material";

const StyledTableHead = ({ columns = [] }) => {
  return (
    <TableHead>
      <TableRow>
        {columns.map((col, index) => (
          <TableCell key={index} align={col.align || "left"} width={col.width} style={{ backgroundColor: "#F1F1F1" }}>
            <strong>{col.label}</strong>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
};

export default StyledTableHead;
